import { useState } from 'react';

interface ImageBoxProps {
  src: string;
  alt: string;
  title?: string;
  imgClassName?: string;
  children?: React.ReactNode;
  className?: string;
}

export default function ImageBox({ src, alt, title, imgClassName = '', children, className = '' }: ImageBoxProps) {
  const [error, setError] = useState(false);

  if (error) return null;

  return (
    <div className={className}>
      <img
        src={src}
        alt={alt}
        title={title}
        className={imgClassName}
        onError={() => setError(true)}
      />
      {children}
    </div>
  );
}